import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: { // all data
        UserSessionData: {},
    },
    mutations: {
        setUserSessionData(state, data) {
            state.UserSessionData = data;
        }
    },
    getters: {
        getUserSessionData: (state) => {
            return state.UserSessionData;
        }
    }
});